<template>
  <div class="home">
    <main class="main" data-v-109a143a="">
      <div data-v-109a143a="">
        <section class="new-hero">
          <div class="new-hero-inner">
            <div class="new-hero-copy">
              <p class="new-hero-eyebrow">{{ texts.heroEyebrow }}</p>
              <h1 class="new-hero-title">{{ texts.heroTitle }}</h1>
              <p class="new-hero-subtitle">{{ texts.heroSubtitle }}</p>
              <div class="new-hero-actions">
                <button class="new-button new-button-primary" @click="tryout()">
                  {{ texts.tryFree }} <span aria-hidden="true">&#8599;</span>
                </button>
                <a class="new-button new-button-secondary" href="#capabilities">
                  {{ texts.viewCases }}
                </a>
              </div>
              <div class="new-hero-metrics" aria-label="Platform highlights">
                <div v-for="metric in texts.heroMetrics" :key="metric.label" class="new-metric">
                  <strong>{{ metric.value }}</strong>
                  <span>{{ metric.label }}</span>
                </div>
              </div>
            </div>

            <div class="new-product-stage">
              <div class="new-stage-label">
                <span class="new-stage-status"></span>
                {{ texts.liveProduct }}
              </div>
              <div class="new-product-window">
                <div class="new-window-bar">
                  <span></span><span></span><span></span>
                  <small>BAILYHANGA / OVERVIEW</small>
                </div>
                <video
                  id="videoPlay"
                  src="@/assets/3c8c0d4eec4442c3c7b492bd2440fb1e.mp4"
                  playsinline
                  autoplay
                  loop
                  muted
                  disablepictureinpicture
                  class="new-product-video"
                ></video>
              </div>
              <div class="new-stage-note">{{ texts.stageNote }}</div>
            </div>
          </div>
        </section>

        <!-- <div class="w-full max-w-7xl mx-auto px-15px -mt-10 lg:-mt-13 lg:px-0">
          <div data-v-13cd1c6f="" class="box">
            <div class="carousel-container">
              <div class="carousel" ref="carousel">
                <img
                  v-for="(image, index) in images"
                  :key="index"
                  :src="require('@/assets/authlogo' + image.src)"
                  :style="{ width: image.width }"
                />
              </div>
            </div>
          </div>
        </div> -->

        <section id="capabilities" class="new-capabilities">
          <div class="new-capabilities-head">
            <p>{{ texts.capabilityEyebrow }}</p>
            <h2>{{ texts.coreTitle }}</h2>
            <span>{{ texts.coreSubtitle }}</span>
          </div>
          <div class="new-capability-list">
            <article v-for="(card, index) in coreCards" :key="card.title" class="new-capability-row">
              <span class="new-capability-index">{{ String(index + 1).padStart(2, "0") }}</span>
              <h3>{{ card.title }}</h3>
              <p>{{ card.desc }}</p>
              <span class="new-capability-arrow" aria-hidden="true">&#8594;</span>
            </article>
          </div>
        </section>

        <div data-v-b7d2c1b8="" class="lx-home-module-container">
          <div data-v-b7d2c1b8="" class="lx-home-module">
            <div
              data-v-b7d2c1b8=""
              data-aos="fade-up"
              class="lx-home-module-item aos-init aos-animate"
            >
              <div data-v-47b03c32="" data-v-b7d2c1b8="" class="lx-list">
                <header data-v-47b03c32="" class="lx-list-header">
                  {{ coreCards[0].title }}
                </header>
                <p data-v-47b03c32="" class="lx-list-description">
                  <span data-v-b7d2c1b8="" data-v-47b03c32=""
                    >{{ coreCards[0].desc }}</span
                  >
                </p>
                <div data-v-47b03c32="" class="mt-4 block lg:hidden">
                  <img
                    data-v-47b03c32=""
                    width="100%"
                    src="@/assets/343ddf442b0a79ab03a900489d23504a.png"
                    alt="进销存一体管理"
                  />
                </div>
                <ul data-v-47b03c32="" class="lx-list-container">
                  <li
                    data-v-30e904fc=""
                    data-v-b7d2c1b8=""
                    class="lx-list-item"
                    data-v-47b03c32=""
                  >
                    {{ texts.moduleSections[0].items[0].title }}
                    <p data-v-30e904fc="" class="lx-list-item-detail">
                      {{ texts.moduleSections[0].items[0].desc }}
                    </p>
                  </li>
                  <li
                    data-v-30e904fc=""
                    data-v-b7d2c1b8=""
                    class="lx-list-item"
                    data-v-47b03c32=""
                  >
                    {{ texts.moduleSections[0].items[1].title }}
                    <p data-v-30e904fc="" class="lx-list-item-detail">
                      {{ texts.moduleSections[0].items[1].desc }}
                    </p>
                  </li>
                  <li
                    data-v-30e904fc=""
                    data-v-b7d2c1b8=""
                    class="lx-list-item"
                    data-v-47b03c32=""
                  >
                    {{ texts.moduleSections[0].items[2].title }}
                    <p data-v-30e904fc="" class="lx-list-item-detail">
                      {{ texts.moduleSections[0].items[2].desc }}
                    </p>
                  </li>
                  <li
                    data-v-30e904fc=""
                    data-v-b7d2c1b8=""
                    class="lx-list-item"
                    data-v-47b03c32=""
                  >
                    {{ texts.moduleSections[0].items[3].title }}
                    <p data-v-30e904fc="" class="lx-list-item-detail">
                      {{ texts.moduleSections[0].items[3].desc }}
                    </p>
                  </li>
                </ul>
                <div
                  data-v-47b03c32=""
                  class="space-x-4 flex"
                  style="font-size: 0px"
                >
                  <el-button type="primary" size="large" @click="tryout()"
                    >{{ texts.tryNow }}<el-icon class="el-icon--right"
                      ><ArrowRight /></el-icon
                  ></el-button>
                </div>
                <div data-v-47b03c32="" class="bg-grey" style="display: none">
                  <div data-v-47b03c32="" class="video md:block">
                    <div data-v-47b03c32="" id="lx-player-1">
                      <i
                        data-v-47b03c32=""
                        class="close-video iconfont icon-close"
                      ></i>
                    </div>
                    <div
                      data-v-47b03c32=""
                      class="video-text flex justify-center items-center h-24"
                    >
                      <p
                        data-v-47b03c32=""
                        class="text-2xl font-medium inline-block mr-4"
                      >
                        XINHE TRADING (HONGKONG) LIMITED，助力实现精细管理和业务增长
                      </p>
                      <button
                        data-v-47b03c32=""
                        type="button"
                        class="el-button h-10 el-button--primary el-button--medium"
                      >
                        <!----><!----><span>立即体验功能</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div data-v-b7d2c1b8="" class="img-container">
                <img
                  data-v-b7d2c1b8=""
                  width="100%"
                  src="@/assets/343ddf442b0a79ab03a900489d23504a.png"
                  alt="XINHE TRADING (HONGKONG) LIMITED官网-跨境电商ERP软件平台_亚马逊ERP管理系统"
                />
              </div>
            </div>
          </div>
          <div data-v-b7d2c1b8="" class="lx-home-module">
            <div
              data-v-b7d2c1b8=""
              data-aos="fade-up"
              class="lx-home-module-item aos-init"
            >
              <div data-v-47b03c32="" data-v-b7d2c1b8="" class="lx-list">
                <header data-v-47b03c32="" class="lx-list-header">
                  {{ texts.moduleSections[1].title }}
                </header>
                <p data-v-47b03c32="" class="lx-list-description">
                  <span data-v-b7d2c1b8="" data-v-47b03c32=""
                    >{{ texts.moduleSections[1].desc }}</span
                  >
                </p>
                <div data-v-47b03c32="" class="mt-4 block lg:hidden">
                  <img
                    data-v-47b03c32=""
                    width="100%"
                    src="@/assets/4885c677d7dee76b7961b68adc181892.png"
                    alt="财务精准管理"
                  />
                </div>
                <ul data-v-47b03c32="" class="lx-list-container">
                  <li
                    data-v-30e904fc=""
                    data-v-b7d2c1b8=""
                    class="lx-list-item"
                    data-v-47b03c32=""
                  >
                    <p data-v-30e904fc="" class="lx-list-item-detail"></p>
                  </li>
                  <li
                    data-v-30e904fc=""
                    data-v-b7d2c1b8=""
                    class="lx-list-item"
                    data-v-47b03c32=""
                  >
                    {{ texts.moduleSections[1].items[0].title }}
                    <p data-v-30e904fc="" class="lx-list-item-detail">
                      {{ texts.moduleSections[1].items[0].desc }}
                    </p>
                  </li>
                  <li
                    data-v-30e904fc=""
                    data-v-b7d2c1b8=""
                    class="lx-list-item"
                    data-v-47b03c32=""
                  >
                    {{ texts.moduleSections[1].items[1].title }}
                    <p data-v-30e904fc="" class="lx-list-item-detail">
                      {{ texts.moduleSections[1].items[1].desc }}
                    </p>
                  </li>
                  <li
                    data-v-30e904fc=""
                    data-v-b7d2c1b8=""
                    class="lx-list-item"
                    data-v-47b03c32=""
                  >
                    {{ texts.moduleSections[1].items[2].title }}
                    <p data-v-30e904fc="" class="lx-list-item-detail">
                      {{ texts.moduleSections[1].items[2].desc }}
                    </p>
                  </li>
                </ul>
                <div
                  data-v-47b03c32=""
                  class="space-x-4 flex"
                  style="font-size: 0px"
                >
                  <el-button type="primary" size="large" @click="tryout()"
                    >{{ texts.tryNow }}<el-icon class="el-icon--right"
                      ><ArrowRight /></el-icon
                  ></el-button>
                  <!---->
                  <!---->
                </div>
                <div data-v-47b03c32="" class="bg-grey" style="display: none">
                  <div data-v-47b03c32="" class="video md:block">
                    <div data-v-47b03c32="" id="lx-player-9">
                      <i
                        data-v-47b03c32=""
                        class="close-video iconfont icon-close"
                      ></i>
                    </div>
                    <div
                      data-v-47b03c32=""
                      class="video-text flex justify-center items-center h-24"
                    >
                      <p
                        data-v-47b03c32=""
                        class="text-2xl font-medium inline-block mr-4"
                      >
                        XINHE TRADING (HONGKONG) LIMITED，助力实现精细管理和业务增长
                      </p>
                      <button
                        data-v-47b03c32=""
                        type="button"
                        class="el-button h-10 el-button--primary el-button--medium"
                      >
                        <!----><!----><span>立即体验功能</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div data-v-b7d2c1b8="" class="img-container">
                <img
                  data-v-b7d2c1b8=""
                  width="100%"
                  src="@/assets/4885c677d7dee76b7961b68adc181892.png"
                  alt="XINHE TRADING (HONGKONG) LIMITED官网-跨境电商ERP软件平台_亚马逊ERP管理系统"
                />
              </div>
            </div>
          </div>
          <div data-v-b7d2c1b8="" class="lx-home-module">
            <div
              data-v-b7d2c1b8=""
              data-aos="fade-up"
              class="lx-home-module-item aos-init"
            >
              <div data-v-47b03c32="" data-v-b7d2c1b8="" class="lx-list">
                <header data-v-47b03c32="" class="lx-list-header">
                  {{ texts.moduleSections[2].title }}
                </header>
                <p data-v-47b03c32="" class="lx-list-description">
                  <span data-v-b7d2c1b8="" data-v-47b03c32=""
                    >{{ texts.moduleSections[2].desc }}</span
                  >
                </p>
                <div data-v-47b03c32="" class="mt-4 block lg:hidden">
                  <img
                    data-v-47b03c32=""
                    width="100%"
                    src="@/assets/30f52d6afb998b2136bda6967d27caf9.png"
                    alt="多维度数据报表"
                  />
                </div>
                <ul data-v-47b03c32="" class="lx-list-container">
                  <li
                    data-v-30e904fc=""
                    data-v-b7d2c1b8=""
                    class="lx-list-item"
                    data-v-47b03c32=""
                  >
                    {{ texts.moduleSections[2].items[0].title }}
                    <p data-v-30e904fc="" class="lx-list-item-detail">
                      {{ texts.moduleSections[2].items[0].desc }}
                    </p>
                  </li>
                  <li
                    data-v-30e904fc=""
                    data-v-b7d2c1b8=""
                    class="lx-list-item"
                    data-v-47b03c32=""
                  >
                    {{ texts.moduleSections[2].items[1].title }}
                    <p data-v-30e904fc="" class="lx-list-item-detail">
                      {{ texts.moduleSections[2].items[1].desc }}
                    </p>
                  </li>
                  <li
                    data-v-30e904fc=""
                    data-v-b7d2c1b8=""
                    class="lx-list-item"
                    data-v-47b03c32=""
                  >
                    {{ texts.moduleSections[2].items[2].title }}
                    <p data-v-30e904fc="" class="lx-list-item-detail">
                      {{ texts.moduleSections[2].items[2].desc }}
                    </p>
                  </li>
                </ul>
                <div
                  data-v-47b03c32=""
                  class="space-x-4 flex"
                  style="font-size: 0px"
                >
                  <el-button type="primary" size="large" @click="tryout()"
                    >{{ texts.tryNow }}<el-icon class="el-icon--right"
                      ><ArrowRight /></el-icon
                  ></el-button>
                  <!---->
                  <!---->
                </div>
                <div data-v-47b03c32="" class="bg-grey" style="display: none">
                  <div data-v-47b03c32="" class="video md:block">
                    <div data-v-47b03c32="" id="lx-player-11">
                      <i
                        data-v-47b03c32=""
                        class="close-video iconfont icon-close"
                      ></i>
                    </div>
                    <div
                      data-v-47b03c32=""
                      class="video-text flex justify-center items-center h-24"
                    >
                      <p
                        data-v-47b03c32=""
                        class="text-2xl font-medium inline-block mr-4"
                      >
                        XINHE TRADING (HONGKONG) LIMITED，助力实现精细管理和业务增长
                      </p>
                      <button
                        data-v-47b03c32=""
                        type="button"
                        class="el-button h-10 el-button--primary el-button--medium"
                      >
                        <!----><!----><span>立即体验功能</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div data-v-b7d2c1b8="" class="img-container">
                <img
                  data-v-b7d2c1b8=""
                  width="100%"
                  src="@/assets/30f52d6afb998b2136bda6967d27caf9.png"
                  alt="XINHE TRADING (HONGKONG) LIMITED官网-跨境电商ERP软件平台_亚马逊ERP管理系统"
                />
              </div>
            </div>
          </div>
        </div>

        <section class="sp-api-brief-section">
          <div class="sp-api-brief-card">
            <div class="sp-api-brief-head">
              <p class="sp-api-brief-tag">Amazon SP-API</p>
              <h3>{{ texts.compliance.title }}</h3>
              <p class="sp-api-brief-text">
                {{ texts.compliance.desc }}
              </p>
            </div>
            <div class="sp-api-brief-grid">
              <div class="sp-api-brief-item">
                <strong>{{ texts.compliance.items[0].title }}</strong>
                <span>{{ texts.compliance.items[0].desc }}</span>
              </div>
              <div class="sp-api-brief-item">
                <strong>{{ texts.compliance.items[1].title }}</strong>
                <span>{{ texts.compliance.items[1].desc }}</span>
              </div>
              <div class="sp-api-brief-item">
                <strong>{{ texts.compliance.items[2].title }}</strong>
                <span>{{ texts.compliance.items[2].desc }}</span>
              </div>
              <div class="sp-api-brief-item">
                <strong>{{ texts.compliance.items[3].title }}</strong>
                <span>{{ texts.compliance.items[3].desc }}</span>
              </div>
            </div>
            <div class="sp-api-brief-actions">
              <router-link :to="{ name: 'spApiComplianceDetail' }" class="sp-api-link primary">
                {{ texts.compliance.links[0] }}
              </router-link>
              <router-link :to="{ name: 'BrandAnalyticsDetail' }" class="sp-api-link">
                {{ texts.compliance.links[1] }}
              </router-link>
              <router-link :to="{ name: 'privacyDetail' }" class="sp-api-link">
                {{ texts.compliance.links[2] }}
              </router-link>
            </div>
          </div>
        </section>

        <div
          class="section-reason w-full max-w-7xl mx-auto text-center pt-20 lg:pt-30 lg:pb-40"
        >
          <div class="w-full px-15px mb-4 lg:px-0 lg:mb-0">
            <div
              data-v-57c9ab6d=""
              class="flex justify-center flex-col items-center lx-large-title aos-init aos-animate"
              data-aos="fade-up"
            >
              <h3
                data-v-57c9ab6d=""
                class="lx-title w-full"
                style="text-align: center"
              >
                {{ texts.reason.title }}
              </h3>
              <div
                data-v-57c9ab6d=""
                class="max-w-840px text-sm px-15px lg:text-lg lg:px-0 font-light text-textContent text-center"
              >
                {{ texts.reason.desc }}
              </div>
            </div>
          </div>
          <div class="mt-20 grid grid-cols-3 gap-x-25">
            <div data-v-5f115aee="" class="section-reason-card-item">
              <div
                data-v-5f115aee=""
                class="flex flex-col items-center py-6 px-2.5 lg:pt-6 lg:pb-9 lg:px-10"
              >
                <el-icon :size="50" color="#409efc"><Clock /></el-icon>
                <p data-v-5f115aee="" class="lx-reason-card-title">
                  {{ texts.reason.cards[0].title }}
                </p>
                <p
                  data-v-5f115aee=""
                  class="text-textPrimary font-normal text-sm mt-2 lg:text-lg lg:mt-2"
                >
                  {{ texts.reason.cards[0].subtitle }}
                </p>
                <div data-v-5f115aee="" class="mt-6 mt-6">
                  <p
                    data-v-5f115aee=""
                    class="text-textPrimary font-light mb-1 lg:text-sm lg:mb-2 text-xs"
                  >
                    {{ texts.reason.cards[0].points[0] }}
                  </p>
                  <p
                    data-v-5f115aee=""
                    class="text-textPrimary font-light mb-1 lg:text-sm lg:mb-2 text-xs"
                  >
                    {{ texts.reason.cards[0].points[1] }}
                  </p>
                  <p
                    data-v-5f115aee=""
                    class="text-textPrimary font-light mb-1 lg:text-sm lg:mb-2 text-xs"
                  >
                    {{ texts.reason.cards[0].points[2] }}
                  </p>
                </div>
              </div>
              <div data-v-5f115aee="" class="lx-reason-card-type">
                <p data-v-5f115aee="" class="lx-reason-tip">10+</p>
                <p data-v-5f115aee="" class="lx-reason-tip-description">
                  {{ texts.reason.cards[0].metricLabel }}
                </p>
              </div>
            </div>
            <div data-v-5f115aee="" class="section-reason-card-item">
              <div
                data-v-5f115aee=""
                class="flex flex-col items-center py-6 px-2.5 lg:pt-6 lg:pb-9 lg:px-10"
              >
                <el-icon :size="50" color="#409efc"><CircleCheck /></el-icon>
                <p data-v-5f115aee="" class="lx-reason-card-title">
                  {{ texts.reason.cards[1].title }}
                </p>
                <p
                  data-v-5f115aee=""
                  class="text-textPrimary font-normal text-sm mt-2 lg:text-lg lg:mt-2"
                >
                  {{ texts.reason.cards[1].subtitle }}
                </p>
                <div data-v-5f115aee="" class="mt-6 mt-6">
                  <p
                    data-v-5f115aee=""
                    class="text-textPrimary font-light mb-1 lg:text-sm lg:mb-2 text-xs"
                  >
                    {{ texts.reason.cards[1].points[0] }}
                  </p>
                  <p
                    data-v-5f115aee=""
                    class="text-textPrimary font-light mb-1 lg:text-sm lg:mb-2 text-xs"
                  >
                    {{ texts.reason.cards[1].points[1] }}
                  </p>
                  <p
                    data-v-5f115aee=""
                    class="text-textPrimary font-light mb-1 lg:text-sm lg:mb-2 text-xs"
                  >
                    {{ texts.reason.cards[1].points[2] }}
                  </p>
                </div>
              </div>
              <div data-v-5f115aee="" class="lx-reason-card-type">
                <p data-v-5f115aee="" class="lx-reason-tip">0.1s</p>
                <p data-v-5f115aee="" class="lx-reason-tip-description">
                  {{ texts.reason.cards[1].metricLabel }}
                </p>
              </div>
            </div>
            <div data-v-5f115aee="" class="section-reason-card-item">
              <div
                data-v-5f115aee=""
                class="flex flex-col items-center py-6 px-2.5 lg:pt-6 lg:pb-9 lg:px-10"
              >
                <el-icon :size="50" color="#409efc"><User /></el-icon>
                <p data-v-5f115aee="" class="lx-reason-card-title">
                  {{ texts.reason.cards[2].title }}
                </p>
                <p
                  data-v-5f115aee=""
                  class="text-textPrimary font-normal text-sm mt-2 lg:text-lg lg:mt-2"
                >
                  {{ texts.reason.cards[2].subtitle }}
                </p>
                <div data-v-5f115aee="" class="mt-6 mt-6">
                  <p
                    data-v-5f115aee=""
                    class="text-textPrimary font-light mb-1 lg:text-sm lg:mb-2 text-xs"
                  >
                    {{ texts.reason.cards[2].points[0] }}
                  </p>
                  <p
                    data-v-5f115aee=""
                    class="text-textPrimary font-light mb-1 lg:text-sm lg:mb-2 text-xs"
                  >
                    {{ texts.reason.cards[2].points[1] }}
                  </p>
                  <p
                    data-v-5f115aee=""
                    class="text-textPrimary font-light mb-1 lg:text-sm lg:mb-2 text-xs"
                  >
                    {{ texts.reason.cards[2].points[2] }}
                  </p>
                </div>
              </div>
              <div data-v-5f115aee="" class="lx-reason-card-type">
                <p data-v-5f115aee="" class="lx-reason-tip">20+</p>
                <p data-v-5f115aee="" class="lx-reason-tip-description">
                  {{ texts.reason.cards[2].metricLabel }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
    <!-- <img alt="Vue logo" src="../assets/logo.png"> -->
    <!-- <HelloWorld msg="Welcome to Your Vue.js App"/> -->
  </div>
</template>
<script setup>
import { ArrowRight, Clock, CircleCheck, User } from "@element-plus/icons-vue";
</script>
<script>
import { localeState } from "@/utils/locale";

export default {
  data() {
    return {
      copy: {
        zh: {
          heroEyebrow: "全球电商 · 一体化经营系统",
          heroTitle: "XINHE TRADING (HONGKONG) LIMITED",
          heroSubtitle: "50万+跨境卖家的一致选择，支持20+主流跨境平台，助力卖家全球出海",
          tryFree: "立即免费试用",
          viewCases: "查看成功案例",
          liveProduct: "产品实时演示",
          stageNote: "经营、库存与财务数据，在一个工作台完成闭环。",
          heroMetrics: [
            { value: "20+", label: "跨境平台" },
            { value: "300+", label: "海外仓连接" },
            { value: "250+", label: "物流服务商" },
          ],
          capabilityEyebrow: "CAPABILITIES / 01",
          coreTitle: "核心功能",
          coreSubtitle: "打通跨境电商业务全流程，闭环管理业务，实现业绩增长",
          cards: [
            ["进销存一体管理", "结合全球销量与货物运输周期等提供补货建议，提前安排采购或发货"],
            ["财务精准管理", "每日实时利润统计，订单级回款跟踪，自动提现，业财一体化管理"],
            ["多维度数据报表", "一表汇总公司经营数据情况，快速洞察问题，调整业务策略"],
            ["全周期广告管理", "支持以产品为中心进行广告投前、投中、投后管理，实现自动化投放与策略优化"],
            ["高效运营工具", "实时监控关键词排名、竞品监控、AI 文案等工具，辅助运营决策"],
            ["售后客服管理", "自动分类汇总分析客户反馈，统一管理 RMA 品质问题、邮件信息等"],
            ["风险全维管理", "权限最小化管理，促销、库存、财务、广告等异常提前预警，自定义审批流，预防风险"],
            ["手机端随时用", "支持移动端看数据、调广告、审批单据、回站内信，并自动推送业绩报告"],
          ],
          tryNow: "立即试用",
          moduleSections: [
            {
              items: [
                { title: "采购业务场景全覆盖", desc: "支持1688、线下下单、委外加工、退换货等采购方式，可按产品、供应商、采购员等维度管理采购" },
                { title: "物流全链条追踪管理", desc: "全链条跟踪物流轨迹，对比物流价格，考核物流商绩效，自动物流对账，优化物流成本" },
                { title: "智能补货建议", desc: "自动追踪全球销量与库存情况，多物流渠道计算，提供连续补货计划，提前做好资金规划" },
                { title: "一站式管库存", desc: "集成300+海外仓、250+物流商，支持一件代发与库存对比，统一管理本地仓、海外仓、FBA仓库存和在途库存" },
              ],
            },
            {
              title: "财务精准管理",
              desc: "每日实时利润统计，订单级回款跟踪，自动提现，业财一体化管理",
              items: [
                { title: "实时看利润", desc: "精准核算利润，实时整合提供利润报表，反哺销售决策调整" },
                { title: "成本严控制", desc: "业务成本一目了然，隐形费用自动识别，精准统计所有成本" },
                { title: "资金流追踪", desc: "打通下单、付款、发货、结算、回款全链路，自动跟踪每一笔订单的回款" },
              ],
            },
            {
              title: "多维度数据报表",
              desc: "一表汇总公司经营数据情况，快速洞察问题，调整业务策略",
              items: [
                { title: "全局数据看板", desc: "首页看板总览全局，销量分析、广告表现等数据一目了然，便于了解核心数据快速决策" },
                { title: "多维数据报表", desc: "自动提供人、财、货相关数据报表，随时了解人员、货物、财务表现，支撑业务决策" },
                { title: "深度数据分析", desc: "支持自定义数据交叉分析，数据环比趋势分析与展示，且可下载按需分析数据" },
              ],
            },
          ],
          compliance: {
            title: "公开服务说明与数据合规承诺",
            desc: "本系统是面向亚马逊卖家及品牌所有者的授权 SaaS 管理工具，用于订单、库存、履约、财务、广告及经营分析等业务场景。我们仅在客户明确授权后访问其店铺或品牌数据。",
            items: [
              { title: "不出售数据", desc: "不会出售、转让、出租或公开披露通过 Amazon SP-API 获取的数据。" },
              { title: "不做公开聚合", desc: "不会将多个卖家或多个品牌的数据汇总后对外展示、分发或售卖。" },
              { title: "按账户隔离", desc: "每个客户的数据独立隔离，仅供其自身团队在授权范围内使用。" },
              { title: "功能与权限一致", desc: "仅申请为订单、履约、库存、报表和品牌分析等功能所必需的 API 权限。" },
            ],
            links: ["查看 SP-API 合规说明", "查看品牌分析功能", "查看隐私政策"],
          },
          reason: {
            title: "为什么选择XINHE TRADING (HONGKONG) LIMITED",
            desc: "选择XINHE TRADING (HONGKONG) LIMITED即选择了精细化管理的模式，全面赋能实现业务增长",
            cards: [
              {
                title: "全生态产品",
                subtitle: "贴合跨境卖家核心使用场景",
                points: ["SaaS软件，无需下载即可使用", "对接支付、物流等系统，全链路闭环管理", "功能版块全，包含进销存、财务、广告等"],
                metricLabel: "跨境产品模块",
              },
              {
                title: "全方位保障",
                subtitle: "深度开发能力与数据安全护航",
                points: ["自研亿级任务调度引擎，运行快速", "定期检测漏洞，签署、严守保密协议", "亚马逊SPN服务商，国家高新技术企业认定"],
                metricLabel: "快速响应",
              },
              {
                title: "全周期服务",
                subtitle: "全程专业服务，满足卖家需求",
                points: ["软件顾问、实施、售后全流程服务", "一体化专业服务，深度赋能客户", "为软件使用负责，持续交付新功能"],
                metricLabel: "服务中心",
              },
            ],
          },
        },
        en: {
          heroEyebrow: "GLOBAL COMMERCE · ONE OPERATING SYSTEM",
          heroTitle: "XINHE TRADING (HONGKONG) LIMITED",
          heroSubtitle:
            "Trusted by 500,000+ cross-border sellers, supporting 20+ major marketplaces to help merchants grow globally.",
          tryFree: "Start Free Trial",
          viewCases: "View Success Stories",
          liveProduct: "Live product view",
          stageNote: "Operations, inventory, and finance connected in one workspace.",
          heroMetrics: [
            { value: "20+", label: "Marketplaces" },
            { value: "300+", label: "Warehouses" },
            { value: "250+", label: "Logistics partners" },
          ],
          capabilityEyebrow: "CAPABILITIES / 01",
          coreTitle: "Core Features",
          coreSubtitle:
            "Connect the entire cross-border commerce workflow, close the operational loop, and accelerate growth.",
          cards: [
            ["Inventory & Supply Management", "Provide replenishment suggestions based on global sales and shipping cycles so teams can plan purchasing and shipping earlier."],
            ["Financial Management", "Track daily profit in real time, follow order-level settlements, and support integrated finance and operations management."],
            ["Multi-Dimensional Reports", "Consolidate operating data into one view to quickly identify issues and adjust strategy."],
            ["Full-Funnel Ad Management", "Manage ads before, during, and after delivery with product-centered workflows and automated optimization."],
            ["Operations Toolkit", "Monitor keyword rankings, watch competitors, and use AI content tools to support faster decisions."],
            ["After-Sales Service", "Classify customer feedback automatically and centralize RMA quality issues, emails, and support workflows."],
            ["Risk Control Management", "Apply least-privilege access, detect promotion, inventory, finance, and advertising issues early, and support approval flows."],
            ["Mobile Access Anytime", "Use mobile tools to review data, adjust ads, approve requests, reply to messages, and receive performance reports."],
          ],
          tryNow: "Try Now",
          moduleSections: [
            {
              items: [
                { title: "Full Procurement Coverage", desc: "Support 1688 sourcing, offline purchasing, outsourced manufacturing, and returns while managing procurement by product, supplier, and buyer." },
                { title: "End-to-End Logistics Tracking", desc: "Track logistics across the full chain, compare shipping rates, evaluate carrier performance, automate reconciliation, and reduce shipping costs." },
                { title: "Smart Replenishment Suggestions", desc: "Track global sales and inventory automatically, calculate across multiple logistics channels, and provide continuous replenishment plans." },
                { title: "Unified Inventory Management", desc: "Integrate 300+ overseas warehouses and 250+ logistics providers to manage local, overseas, FBA, and in-transit inventory in one place." },
              ],
            },
            {
              title: "Financial Management",
              desc: "Track profit daily in real time, follow order-level settlements, automate withdrawals, and connect finance with operations.",
              items: [
                { title: "Live Profit Visibility", desc: "Calculate profit accurately and generate real-time profit reports to support sales decisions." },
                { title: "Tight Cost Control", desc: "Make operating costs visible, identify hidden fees automatically, and measure all costs precisely." },
                { title: "Cash Flow Tracking", desc: "Connect ordering, payment, shipping, settlement, and payout into one workflow and track each order's return." },
              ],
            },
            {
              title: "Multi-Dimensional Reports",
              desc: "Bring operating data together in one view so teams can identify issues quickly and adjust strategy.",
              items: [
                { title: "Executive Dashboard", desc: "See sales trends, ad performance, and key metrics at a glance for faster decision-making." },
                { title: "Cross-Functional Reports", desc: "Generate people, finance, and inventory reports automatically to support ongoing business decisions." },
                { title: "Deep Data Analysis", desc: "Support custom cross-analysis, trend comparison, and downloadable reports for deeper operational insight." },
              ],
            },
          ],
          compliance: {
            title: "Public Service Description and Data Compliance Commitment",
            desc: "This system is an authorized SaaS management tool for Amazon sellers and brand owners, covering orders, inventory, fulfillment, finance, advertising, and business analytics. We only access store or brand data after explicit customer authorization.",
            items: [
              { title: "No Data Resale", desc: "We do not sell, transfer, rent, or publicly disclose data obtained through Amazon SP-API." },
              { title: "No Public Aggregation", desc: "We do not aggregate multiple sellers' or brands' data for external display, distribution, or resale." },
              { title: "Account Isolation", desc: "Each customer's data is isolated and only available to that customer's authorized team." },
              { title: "Feature-to-Permission Alignment", desc: "We request only the API permissions necessary for orders, fulfillment, inventory, reporting, and brand analytics features." },
            ],
            links: ["View SP-API Compliance", "View Brand Analytics", "View Privacy Policy"],
          },
          reason: {
            title: "Why Choose Hunan Panxian Intelligent Technology",
            desc: "Choosing our platform means adopting refined operational management to fully empower sustainable growth.",
            cards: [
              {
                title: "Complete Ecosystem",
                subtitle: "Built for the real workflows of cross-border sellers",
                points: ["SaaS software with no installation required", "Connect payments, logistics, and other systems in one closed-loop workflow", "Rich modules covering inventory, finance, advertising, and more"],
                metricLabel: "Product Modules",
              },
              {
                title: "All-Round Protection",
                subtitle: "Strong engineering capability with data security support",
                points: ["Self-developed high-volume task scheduling engine", "Regular vulnerability checks and strict confidentiality standards", "Amazon SPN service provider with national high-tech enterprise recognition"],
                metricLabel: "Fast Response",
              },
              {
                title: "Full-Cycle Service",
                subtitle: "Professional support throughout the seller journey",
                points: ["Consulting, implementation, and after-sales support", "Integrated professional services that empower customers deeply", "Continuous product delivery and long-term responsibility for usage success"],
                metricLabel: "Service Centers",
              },
            ],
          },
        },
      },
      images: [
        { src: "/1e0bcd5e813baa9e03b70b3670440289.png", width: "96px" },
        { src: "/2bdc3db1c8e75607624b73da92ed3c1a.png", width: "96px" },
        { src: "/2cd4f0ce47aee71014763de201b28f56.png", width: "96px" },
        { src: "/7a1b07c94c2a335484791e422c165978.png", width: "96px" },
        { src: "/7eadfbc24ac5e535a54542abddab2b3b.png", width: "96px" },
        { src: "/8a4d3afac701c5937d6c47612e3f1428.png", width: "96px" },
        { src: "/36b83e267fad878468962c097fbbcf9a.png", width: "96px" },
        { src: "/404f58d67d01c6bbef15159cd834f365.png", width: "52.8px" },
        { src: "/445ec5bc764388ae22a0e7ae0f2935bb.png", width: "96px" },
        { src: "/694d3de02a6b1465c5bf179ccc4629f5.png", width: "52.8px" },
        { src: "/777f9c09a3cd6075f5acf37a3eaf455f.png", width: "96px" },
        { src: "/4855e281b97935a54cded33b3ae69309.png", width: "96px" },
        { src: "/57532a32cd73dd27653f265de5d9b554.png", width: "74.39px" },
        { src: "/63883de30bc47f77d2b2111a9f17cff0.png", width: "96px" },
        { src: "/89187b19ae0513a9a732029b2c8b4a51.png", width: "96px" },
        { src: "/185031eeb75240146b47e094d490a80c.png", width: "96px" },
        { src: "/661573a0962cd7d2fc822d9c1757d217.png", width: "96px" },
        { src: "/a7433db37bf5ef24c773b7d4b320b157.png", width: "96px" },
        { src: "/b7ff4aeb99678bd845bafa708ffd5926.png", width: "96px" },
        { src: "/c480a5966bc420e18cf4c1dc01b065dd.png", width: "96px" },
        { src: "/d935570d24e2c0da45e38b65fd3544fb.png", width: "96px" },
        { src: "/eab273e98152635430c8e3fc5f96b304.png", width: "79.19px" },
        { src: "/f798f678600407b4d4277f12259a3cd8.png", width: "96px" },
        { src: "/fa10b142c9e082fa7ea0d6d7ed7b12cf.png", width: "96px" },
      ],
    };
  },
  computed: {
    locale() {
      return localeState.locale;
    },
    texts() {
      return this.copy[this.locale];
    },
    coreCards() {
      return this.texts.cards.map((card) =>
        Array.isArray(card)
          ? { title: card[0], desc: card[1] }
          : card
      );
    },
  },

  mounted() {},
  methods: {
    startAnimation() {
      const carousel = this.$refs.carousel;
      if (!carousel || !carousel.children.length) return;
      const firstImage = carousel.children[0];
      const imageWidth = firstImage.clientWidth;

      // 复制图片以实现无缝循环
      for (let i = 0; i < this.images.length; i++) {
        const clone = carousel.children[i].cloneNode(true);
        carousel.appendChild(clone);
      }

      // 设置动画效果
      carousel.style.animation = `scroll ${
        this.images.length * 0.6
      }s linear infinite`;

      // 动态设置关键帧
      const keyframes = `
        @keyframes scroll {
          0% { transform: translateX(0); }
          100% { transform: translateX(-${imageWidth * this.images.length}px); }
        }
      `;
      const styleSheet = document.createElement("style");
      styleSheet.type = "text/css";
      styleSheet.innerText = keyframes;
      document.head.appendChild(styleSheet);
    },
    tryout() {
      window.location.href =
        this.locale === "en"
          ? "mailto:it_jch@xinhe.space?subject=Product%20Trial%20Inquiry"
          : "mailto:it_jch@xinhe.space?subject=%E4%BA%A7%E5%93%81%E8%AF%95%E7%94%A8%E5%92%A8%E8%AF%A2";
    },
  },

  name: "Home",
  // components: {
  //   HelloWorld
  // }
};
</script>
<style scoped>
.en-main[data-v-109a143a],
.footer[data-v-109a143a],
.main[data-v-109a143a] {
  width: 100%;
}
main {
  display: block;
  unicode-bidi: isolate;
}

@media (min-width: 1024px) {
  .lx-banner-container[data-v-a32e13b0] {
    min-height: 33.75rem;
    padding-left: 0;
    padding-right: 0;
  }
}
.lx-banner-container[data-v-a32e13b0] {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
  display: flex;
  padding-left: 15px;
  padding-right: 15px;
  width: 100%;
}
@media (min-width: 1024px) {
  .lg\:mt-10 {
    margin-top: 2.5rem;
  }
}
@media (min-width: 1024px) {
  .lg\:justify-between {
    justify-content: space-between;
  }
}
@media (min-width: 1024px) {
  .lg\:items-center {
    align-items: center;
  }
}
@media (min-width: 1024px) {
  .lg\:flex-row {
    flex-direction: row;
  }
}
.mb-10 {
  margin-bottom: 2.5rem;
}
.lx-content-container {
  display: flex;
  margin-left: auto;
  margin-right: auto;
  max-width: 80rem;
  width: 100%;
}
@media (min-width: 1024px) {
  .lg\:text-left {
    text-align: left;
  }
}
@media (min-width: 1024px) {
  .lg\:mb-0 {
    margin-bottom: 0;
  }
}

.mb-4 {
  margin-bottom: 1rem;
}
@media (min-width: 1024px) {
  .lx-banner-title[data-v-a32e13b0] {
    font-size: 2.25rem;
    line-height: 3.125rem;
  }
}
.lx-banner-title[data-v-a32e13b0] {
  font-weight: 600;
  font-size: 1.5rem;
  --tw-text-opacity: 1;
  color: rgba(58, 64, 87, var(--tw-text-opacity));
}
.lx-banner-container .hight-light[data-v-a32e13b0] {
  --tw-text-opacity: 1;
  color: rgba(37, 84, 254, var(--tw-text-opacity));
}
@media (min-width: 1024px) {
  .lg\:text-lg {
    font-size: 1.125rem;
  }
}
.text-textContent {
  --tw-text-opacity: 1;
  color: rgba(92, 94, 102, var(--tw-text-opacity));
}
.mb-8 {
  margin-bottom: 2rem;
}
.mt-\[6px\] {
  margin-top: 6px;
}
.text-xs {
  font-size: 0.75rem;
}
.font-light {
  font-weight: 300;
}
.lx-banner-container .source-tip[data-v-a32e13b0] {
  margin-top: 64px;
  color: #a2aeca;
  font-size: 14px;
  padding-bottom: 50px;
}
@media (min-width: 1024px) {
  .lx-banner-container .banner-img[data-v-a32e13b0] {
    border-radius: 1.5rem;
    margin-left: 1.25rem;
    min-width: 50rem;
    width: 50rem;
  }
}
.lx-banner-container .banner-img[data-v-a32e13b0] {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
  border-radius: 1rem;
  border-radius: 1.5rem;
  max-width: 50rem;
  position: relative;
  width: 100%;
}
.lx-banner-container .video-con[data-v-a32e13b0] {
  --tw-bg-opacity: 1;
  background-color: rgba(0, 0, 0, var(--tw-bg-opacity));
  --tw-bg-opacity: 0.5;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 0;
  position: fixed;
  top: 24999.75rem;
  left: 0;
  width: 100%;
  z-index: 99;
}
.lx-banner-container .close-video[data-v-a32e13b0],
.lx-banner-container .play-con[data-v-a32e13b0] {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, var(--tw-text-opacity));
}
@media (min-width: 1024px) {
  .lg\:px-0 {
    padding-left: 0;
    padding-right: 0;
  }
}
@media (min-width: 1024px) {
  .lg\:-mt-13 {
    margin-top: -3.25rem;
  }
}
.w-full {
  width: 100%;
}
.max-w-7xl {
  max-width: 80rem;
}
.mx-auto {
  margin-left: auto;
  margin-right: auto;
}
.box[data-v-13cd1c6f] {
  overflow-x: hidden;
  display: flex;
  flex-direction: row;
  position: relative;
  width: 100%;
  margin-top: 0.75rem;
}

.carousel-container {
  overflow: hidden;
  width: 100%; /* 容器宽度，具体值根据需求设置 */
}

.carousel {
  display: flex;
  white-space: nowrap;
}

.carousel img {
  height: 48px; /* 图片宽度，具体值根据需求设置 */
  flex-shrink: 0;
  margin: 0 20px;
}
@media (min-width: 1024px) {
  .lg\:my-30 {
    margin-top: 2.5rem;
    margin-bottom: 7.5rem;
  }
}
.justify-center {
  justify-content: center;
}
.items-center {
  align-items: center;
}
.flex-col {
  flex-direction: column;
}
.flex {
  display: flex;
}
@media (min-width: 1024px) {
  .lx-middle-title .lx-title[data-v-57c9ab6d] {
    font-size: 2.25rem;
    line-height: 2.75rem;
  }
}
@media (min-width: 1024px) {
  .lx-title[data-v-57c9ab6d] {
    font-size: 2.25rem;
    line-height: 50px;
    margin-bottom: 0.5rem;
  }
}
.lx-title[data-v-57c9ab6d] {
  font-size: 2.25rem;
  color: #1a2035;
  font-weight: 500;
  line-height: 1.75rem;
  margin-bottom: 1.25rem;
  max-width: 840px;
  text-align: center;
  --tw-text-opacity: 1;
  color: rgba(26, 32, 53, var(--tw-text-opacity));
  letter-spacing: 1px;
}
.max-w-840px {
  max-width: 840px;
}
@media (min-width: 1024px) {
  .lg\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
}
@media (min-width: 1024px) {
  .lg\:gap-y-10 {
    -webkit-row-gap: 2.5rem;
    -moz-row-gap: 2.5rem;
    grid-row-gap: 2.5rem;
    row-gap: 2.5rem;
  }
}
@media (min-width: 1024px) {
  .lg\:gap-x-8 {
    -webkit-column-gap: 2rem;
    -moz-column-gap: 2rem;
    grid-column-gap: 2rem;
    column-gap: 2rem;
  }
}
@media (min-width: 1024px) {
  .lg\:mt-16 {
    margin-top: 4rem;
  }
}
.grid {
  display: grid;
}
@media (min-width: 1024px) {
  .core-card[data-v-73a06f5c] {
    padding: 1.5rem 1.5rem 2rem;
  }
}
.core-card[data-v-73a06f5c] {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
  border-radius: 0.75rem;
  display: flex;
  flex-direction: column;
  padding: 1.25rem 0.625rem;
  box-shadow: 0 0 10px rgba(180, 189, 221, 0.08),
    0 6px 14px hsla(0, 0%, 100%, 0.3), 0 12px 20px rgba(180, 189, 221, 0.2);
}
.items-start {
  align-items: flex-start;
}
iframe,
img,
svg,
video {
  display: block;
  vertical-align: middle;
}
@media (min-width: 1024px) {
  .lg\:mt-4 {
    margin-top: 1rem;
  }
}
@media (min-width: 1024px) {
  .lg\:text-22px {
    font-size: 22px;
    line-height: 1;
  }
}
.text-textTitle {
  --tw-text-opacity: 1;
  color: rgba(26, 32, 53, var(--tw-text-opacity));
}
.font-medium {
  font-weight: 500;
}
@media (min-width: 1024px) {
  .lg\:block {
    display: block;
  }
}
.text-textSubtitle {
  --tw-text-opacity: 1;
  color: rgba(58, 64, 87, var(--tw-text-opacity));
}
.text-left {
  text-align: left;
}
.mt-3\.5 {
  margin-top: 0.875rem;
}
.leading-6 {
  line-height: 1.5rem;
}
.font-normal {
  font-weight: 400;
}
.lx-home-module-container[data-v-b7d2c1b8] {
  display: flex;
  flex-direction: column;
}
.lx-home-module-container .lx-home-module[data-v-b7d2c1b8]:nth-child(odd) {
  --tw-bg-opacity: 1;
  background-color: rgba(248, 249, 255, var(--tw-bg-opacity));
}
@media (min-width: 1024px) {
  .lx-home-module-container .lx-home-module[data-v-b7d2c1b8] {
    padding-top: 7.5rem;
    padding-bottom: 7.5rem;
  }
}
.lx-home-module-container
  .lx-home-module:nth-child(odd)
  .lx-home-module-item[data-v-b7d2c1b8] {
  flex-direction: row-reverse;
}
@media (min-width: 1024px) {
  .lx-home-module-container
    .lx-home-module
    .lx-home-module-item[data-v-b7d2c1b8] {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding-left: 0;
    padding-right: 0;
  }
}
.lx-home-module-container
  .lx-home-module
  .lx-home-module-item[data-v-b7d2c1b8] {
  display: flex;

  margin-left: auto;
  margin-right: auto;
  max-width: 80rem;
  padding-left: 15px;
  padding-right: 15px;
}
@media (min-width: 1024px) {
  .lx-home-module-container
    .lx-home-module
    .lx-home-module-item
    .lx-list[data-v-b7d2c1b8] {
    width: 30rem;
    text-align: left;
  }
}
@media (min-width: 1024px) {
  .lx-list .lx-list-header[data-v-47b03c32] {
    font-size: 2.25rem;
  }
}
.lx-list .lx-list-header[data-v-47b03c32] {
  font-weight: 500;
  font-size: 2.25rem;
  --tw-text-opacity: 1;
  color: rgba(26, 32, 53, var(--tw-text-opacity));
  letter-spacing: 1px;
}
@media (min-width: 1024px) {
  .lx-list .lx-list-description[data-v-47b03c32] {
    font-size: 1rem;
  }
}
.lx-list .lx-list-description[data-v-47b03c32] {
  font-weight: 400;
  font-size: 0.875rem;
  margin-top: 0.5rem;
  --tw-text-opacity: 1;
  color: rgba(26, 32, 53, var(--tw-text-opacity));
  letter-spacing: 1px;
}
dd,
dl,
h2,
h3,
p {
  margin: 0;
}
@media (min-width: 1024px) {
  .lg\:hidden {
    display: none;
  }
}
.mt-4 {
  margin-top: 1rem;
}
img,
video {
  max-width: 85%;
  height: auto;
}
@media (min-width: 1024px) {
  .lx-list .lx-list-container[data-v-47b03c32] {
    margin-top: 2rem;
    margin-bottom: 2rem;
  }
}
.lx-list .lx-list-container[data-v-47b03c32] {
  margin-top: 1rem;
  margin-bottom: 1.5rem;
  padding-left: 1.5rem;
}
ul {
  list-style: none;
  margin: 0;
  padding: 0;
}
@media (min-width: 1024px) {
  .lx-list-item[data-v-30e904fc] {
    font-size: 1.125rem;
  }
}
.lx-list-item[data-v-30e904fc] {
  font-weight: 500;
  font-size: 0.875rem;
  line-height: 1.75rem;
  position: relative;
  --tw-text-opacity: 1;
  color: rgba(26, 32, 53, var(--tw-text-opacity));
}
@media (min-width: 1024px) {
  .en-main .lx-list-item .lx-list-item.no-description[data-v-30e904fc],
  .lx-list-item .en-main .lx-list-item.no-description[data-v-30e904fc],
  .lx-list-item .lx-list-item-detail[data-v-30e904fc] {
    font-size: 1rem;
    line-height: 1.75rem;
  }
}
.en-main .lx-list-item .lx-list-item.no-description[data-v-30e904fc],
.lx-list-item .en-main .lx-list-item.no-description[data-v-30e904fc],
.lx-list-item .lx-list-item-detail[data-v-30e904fc] {
  font-weight: 300;
  font-size: 0.875rem;
  line-height: 22px;
  --tw-text-opacity: 1;
  color: rgba(92, 94, 102, var(--tw-text-opacity));
}
.lx-list-item[data-v-30e904fc]:before {
  --tw-bg-opacity: 1;
  background-color: rgba(37, 84, 254, var(--tw-bg-opacity));
  border-radius: 50%;
  position: absolute;
  left: -1.25rem;
  top: 11px;
  content: "";
  width: 6px;
  height: 6px;
  box-shadow: 0 0 0 5px rgba(37, 84, 254, 0.1);
}
.lx-home-module-container .lx-home-module[data-v-b7d2c1b8]:nth-child(2n) {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
}
@media (min-width: 1024px) {
  .lx-home-module-container
    .lx-home-module
    .lx-home-module-item
    .img-container[data-v-b7d2c1b8] {
    display: block;
    width: 40rem;
  }
}
@media (min-width: 1024px) {
  .lx-list[data-v-47b03c32] {
    margin-top: 0;
    width: 30rem;
  }
}
@media (min-width: 1024px) {
  .lg\:pb-40 {
    padding-bottom: 10rem;
  }
}
@media (min-width: 1024px) {
  .lg\:pt-30 {
    padding-top: 7.5rem;
  }
}
.text-center {
  text-align: center;
}
.grid-cols-3 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
.gap-x-25 {
  -webkit-column-gap: 6.25rem;
  -moz-column-gap: 6.25rem;
  grid-column-gap: 6.25rem;
  column-gap: 6.25rem;
}
.mt-20 {
  margin-top: 5rem;
}
.sp-api-brief-section {
  padding: 1rem 15px 0;
}
.sp-api-brief-card {
  background: linear-gradient(135deg, #0f3d91, #2554fe 68%, #73a6ff);
  border-radius: 1.5rem;
  box-shadow: 0 18px 42px rgba(20, 57, 137, 0.18);
  color: #fff;
  margin: 0 auto;
  max-width: 80rem;
  overflow: hidden;
  padding: 2rem 1.25rem;
  text-align: left;
}
.sp-api-brief-tag {
  font-size: 0.875rem;
  letter-spacing: 0.12em;
  margin-bottom: 0.75rem;
  opacity: 0.82;
  text-transform: uppercase;
}
.sp-api-brief-head h3 {
  color: #fff;
  font-size: 1.75rem;
  margin: 0;
}
.sp-api-brief-text {
  color: rgba(255, 255, 255, 0.92);
  line-height: 1.9;
  margin-top: 1rem;
  max-width: 56rem;
}
.sp-api-brief-grid {
  display: grid;
  gap: 1rem;
  margin-top: 1.5rem;
}
.sp-api-brief-item {
  background: rgba(255, 255, 255, 0.12);
  border: 1px solid rgba(255, 255, 255, 0.16);
  border-radius: 1rem;
  display: flex;
  flex-direction: column;
  min-height: 120px;
  padding: 1rem;
}
.sp-api-brief-item strong {
  color: #fff;
  font-size: 1rem;
}
.sp-api-brief-item span {
  color: rgba(255, 255, 255, 0.88);
  line-height: 1.7;
  margin-top: 0.625rem;
}
.sp-api-brief-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.875rem;
  margin-top: 1.5rem;
}
.sp-api-link {
  border: 1px solid rgba(255, 255, 255, 0.68);
  border-radius: 999px;
  color: #fff;
  padding: 0.8rem 1.25rem;
  text-decoration: none;
}
.sp-api-link.primary {
  background: #fff;
  color: #173169;
}
.section-reason-card-item[data-v-5f115aee] {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
  border-radius: 1rem;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0 0 16px 0 rgba(180, 189, 221, 0.1),
    0 6px 14px 0 hsla(0, 0%, 100%, 0.3), 0 16px 20px 0 rgba(180, 189, 221, 0.25);
  transition: all 0.4s ease-in-out;
}
@media (min-width: 1024px) {
  .lg\:pb-9 {
    padding-bottom: 2.25rem;
  }
}
@media (min-width: 1024px) {
  .lg\:pt-6 {
    padding-top: 1.5rem;
  }
}
@media (min-width: 1024px) {
  .lg\:px-10 {
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }
}
.section-reason-card-item .lx-reason-card-title[data-v-5f115aee] {
  font-weight: 500;
  font-size: 1.875rem;
  margin-top: 1rem;
  --tw-text-opacity: 1;
  color: rgba(26, 32, 53, var(--tw-text-opacity));
}
@media (min-width: 1024px) {
  .lg\:mt-2 {
    margin-top: 0.5rem;
  }
}
.text-textPrimary {
  --tw-text-opacity: 1;
  color: rgba(58, 64, 87, var(--tw-text-opacity));
}
.mt-6 {
  margin-top: 1.5rem;
}
@media (min-width: 1024px) {
  .lg\:mb-2 {
    margin-bottom: 0.5rem;
  }
}
@media (min-width: 1024px) {
  .lg\:text-sm {
    font-size: 0.875rem;
  }
}
.section-reason-card-item .lx-reason-card-type[data-v-5f115aee] {
  overflow: hidden;
  padding-top: 1rem;
  padding-bottom: 1.5rem;
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, var(--tw-text-opacity));
  width: 100%;
  border-radius: 0 0 16px 16px;
  background-image: url(https://static.distributetop.com/office-site-new/office-site-upload/img/reason-card-bg.1c4fd50.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.section-reason-card-item .lx-reason-card-type .lx-reason-tip[data-v-5f115aee] {
  font-family: Helvetica Neue;
  font-size: 32px;
  letter-spacing: 2px;
  font-weight: 500;
  line-height: 2.5rem;
}
.section-reason-card-item[data-v-5f115aee]:hover {
  transform: translateY(-8px);
  box-shadow: 10px 10px 38px 0 hsla(0, 0%, 100%, 0.3),
    0 0 14px 0 rgba(202, 210, 238, 0.2),
    28px 36px 50px 0 rgba(180, 189, 221, 0.46);
}
@media (min-width: 1024px) {
  .sp-api-brief-section {
    padding-top: 2rem;
  }
  .sp-api-brief-card {
    padding: 2.5rem;
  }
  .sp-api-brief-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
</style>
<style scoped>
/* Unified visual treatment for the legacy lower-page content. */
.lx-home-module-container {
  background: #fbfaf6;
}
.lx-home-module-container .lx-home-module[data-v-b7d2c1b8],
.lx-home-module-container .lx-home-module[data-v-b7d2c1b8]:nth-child(odd),
.lx-home-module-container .lx-home-module[data-v-b7d2c1b8]:nth-child(2n) {
  background: #fbfaf6;
  border-bottom: 1px solid #dddcd5;
  padding: 112px 0;
  position: relative;
}
.lx-home-module-container .lx-home-module[data-v-b7d2c1b8]:nth-child(2n) {
  background: #edf0e9;
}
.lx-home-module-container .lx-home-module .lx-home-module-item[data-v-b7d2c1b8] {
  gap: 88px;
  max-width: 1280px;
  padding: 0 38px;
}
.lx-home-module-container .lx-home-module:nth-child(odd) .lx-home-module-item[data-v-b7d2c1b8] {
  flex-direction: row-reverse;
}
.lx-home-module-container .lx-home-module:nth-child(2n) .lx-home-module-item[data-v-b7d2c1b8] {
  flex-direction: row;
}
.lx-home-module-container .lx-home-module .lx-home-module-item .lx-list[data-v-b7d2c1b8] {
  text-align: left;
  width: 42%;
}
.lx-home-module-container .lx-home-module .lx-home-module-item .lx-list::before {
  color: #b36b33;
  content: "PRODUCT SYSTEM / 02";
  display: block;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.14em;
  margin-bottom: 22px;
}
.lx-home-module-container .lx-home-module:nth-child(2) .lx-home-module-item .lx-list::before { content: "FINANCE SYSTEM / 03"; }
.lx-home-module-container .lx-home-module:nth-child(3) .lx-home-module-item .lx-list::before { content: "INSIGHT SYSTEM / 04"; }
.lx-list .lx-list-header[data-v-47b03c32] {
  color: #17352d;
  font-family: Georgia, "Times New Roman", serif;
  font-size: 42px;
  font-weight: 400;
  letter-spacing: 0;
  line-height: 1.15;
}
.lx-list .lx-list-description[data-v-47b03c32] {
  color: #66716b;
  font-size: 15px;
  letter-spacing: 0;
  line-height: 1.7;
  margin-top: 18px;
}
.lx-list .lx-list-container[data-v-47b03c32] {
  border-top: 1px solid #d3d6ce;
  margin: 30px 0;
  padding: 0;
}
.lx-list-item[data-v-30e904fc] {
  border-bottom: 1px solid #d3d6ce;
  color: #17352d;
  font-size: 14px;
  line-height: 1.5;
  padding: 15px 0 14px 24px;
}
.lx-list-item[data-v-30e904fc]:before {
  background: #b36b33;
  border-radius: 0;
  box-shadow: none;
  height: 1px;
  left: 0;
  top: 25px;
  width: 10px;
}
.lx-list-item .lx-list-item-detail[data-v-30e904fc] {
  color: #778079;
  font-size: 12px;
  line-height: 1.65;
  margin-top: 5px;
}
.lx-list :deep(.el-button--primary) {
  background: #17352d;
  border-color: #17352d;
  border-radius: 2px;
  min-height: 46px;
  padding: 0 20px;
}
.lx-home-module-container .lx-home-module .lx-home-module-item .img-container[data-v-b7d2c1b8] {
  align-items: center;
  background: #e3e8df;
  border: 1px solid #d2d8cf;
  display: flex;
  min-height: 460px;
  overflow: hidden;
  padding: 34px;
  position: relative;
  width: 54%;
}
.lx-home-module-container .lx-home-module:nth-child(2n) .lx-home-module-item .img-container[data-v-b7d2c1b8] {
  background: #fbfaf6;
}
.lx-home-module-container .lx-home-module .lx-home-module-item .img-container::after {
  border: 1px solid rgba(179, 107, 51, 0.35);
  content: "";
  height: 62px;
  position: absolute;
  right: -26px;
  top: -26px;
  transform: rotate(45deg);
  width: 62px;
}
.lx-home-module-container .lx-home-module .lx-home-module-item .img-container img {
  margin: auto;
  max-width: 100%;
}

.sp-api-brief-section {
  background: #102d26;
  padding: 108px 36px;
}
.sp-api-brief-card {
  background: transparent;
  border-radius: 0;
  box-shadow: none;
  color: #f6f3ea;
  display: grid;
  gap: 50px 72px;
  grid-template-columns: 0.72fr 1.28fr;
  max-width: 1280px;
  padding: 0;
}
.sp-api-brief-head h3 {
  color: #f6f3ea;
  font-family: Georgia, "Times New Roman", serif;
  font-size: 40px;
  font-weight: 400;
  line-height: 1.15;
}
.sp-api-brief-tag { color: #edbf5e; font-size: 11px; font-weight: 700; opacity: 1; }
.sp-api-brief-text { color: rgba(246, 243, 234, 0.62); font-size: 14px; line-height: 1.8; }
.sp-api-brief-grid {
  border-top: 1px solid rgba(246, 243, 234, 0.2);
  gap: 0;
  grid-template-columns: 1fr;
  margin: 0;
}
.sp-api-brief-item {
  background: transparent;
  border: 0;
  border-bottom: 1px solid rgba(246, 243, 234, 0.2);
  border-radius: 0;
  min-height: 0;
  padding: 18px 0;
}
.sp-api-brief-item strong { color: #edbf5e; font-size: 14px; }
.sp-api-brief-item span { color: rgba(246, 243, 234, 0.63); font-size: 12px; margin-top: 6px; }
.sp-api-brief-actions { grid-column: 2; margin: -28px 0 0; }
.sp-api-link {
  border-color: rgba(246, 243, 234, 0.35);
  border-radius: 2px;
  color: #f6f3ea;
  font-size: 12px;
  padding: 11px 15px;
}
.sp-api-link.primary { background: #edbf5e; border-color: #edbf5e; color: #102d26; }

.section-reason {
  background: #f3f0e8;
  max-width: none;
  padding: 112px max(36px, calc((100vw - 1280px) / 2));
}
.section-reason .lx-title[data-v-57c9ab6d] {
  color: #17352d;
  font-family: Georgia, "Times New Roman", serif;
  font-size: 46px;
  font-weight: 400;
  letter-spacing: 0;
  line-height: 1.12;
}
.section-reason .lx-large-title > div { color: #747c76; font-size: 15px; line-height: 1.7; }
.section-reason .mt-20.grid {
  border-bottom: 1px solid #c9ccc4;
  border-top: 1px solid #c9ccc4;
  gap: 0;
  margin-top: 68px;
}
.section-reason-card-item[data-v-5f115aee] {
  background: transparent;
  border-left: 1px solid #c9ccc4;
  border-radius: 0;
  box-shadow: none;
  justify-content: stretch;
  min-height: 510px;
}
.section-reason-card-item[data-v-5f115aee]:last-child { border-right: 1px solid #c9ccc4; }
.section-reason-card-item[data-v-5f115aee]:hover { box-shadow: none; transform: none; }
.section-reason-card-item > div:first-child { flex: 1; padding: 42px 30px 30px; }
.section-reason-card-item :deep(.el-icon) { color: #b36b33 !important; height: 34px; width: 34px; }
.section-reason-card-item .lx-reason-card-title[data-v-5f115aee] {
  color: #17352d;
  font-family: Georgia, "Times New Roman", serif;
  font-size: 28px;
  font-weight: 400;
}
.section-reason-card-item .text-textPrimary { color: #707a73; line-height: 1.65; }
.section-reason-card-item .lx-reason-card-type[data-v-5f115aee] {
  background: #17352d;
  border-radius: 0;
  color: #edbf5e;
  padding: 18px 12px;
}
.section-reason-card-item .lx-reason-card-type .lx-reason-tip[data-v-5f115aee] {
  font-family: Georgia, "Times New Roman", serif;
  font-size: 30px;
  font-weight: 400;
  letter-spacing: 0;
}
.lx-reason-tip-description { color: rgba(246, 243, 234, 0.58); }

@media (max-width: 900px) {
  .lx-home-module-container .lx-home-module[data-v-b7d2c1b8],
  .lx-home-module-container .lx-home-module[data-v-b7d2c1b8]:nth-child(odd),
  .lx-home-module-container .lx-home-module[data-v-b7d2c1b8]:nth-child(2n) { padding: 72px 0; }
  .lx-home-module-container .lx-home-module .lx-home-module-item[data-v-b7d2c1b8],
  .lx-home-module-container .lx-home-module:nth-child(odd) .lx-home-module-item[data-v-b7d2c1b8],
  .lx-home-module-container .lx-home-module:nth-child(2n) .lx-home-module-item[data-v-b7d2c1b8] {
    flex-direction: column;
    gap: 34px;
    padding: 0 20px;
  }
  .lx-home-module-container .lx-home-module .lx-home-module-item .lx-list[data-v-b7d2c1b8],
  .lx-home-module-container .lx-home-module .lx-home-module-item .img-container[data-v-b7d2c1b8] { width: 100%; }
  .lx-list .lx-list-header[data-v-47b03c32] { font-size: 34px; }
  .lx-home-module-container .lx-home-module .lx-home-module-item .img-container[data-v-b7d2c1b8] { display: none; }
  .lx-list .lg\:hidden { background: #e3e8df; display: block; padding: 18px; }
  .lx-list .lg\:hidden img { margin: auto; max-width: 100%; }
  .sp-api-brief-section { padding: 76px 20px; }
  .sp-api-brief-card { gap: 38px; grid-template-columns: 1fr; }
  .sp-api-brief-actions { grid-column: 1; margin: 0; }
  .sp-api-brief-head h3 { font-size: 34px; }
  .section-reason { padding: 76px 20px; }
  .section-reason .lx-title[data-v-57c9ab6d] { font-size: 36px; }
  .section-reason .mt-20.grid { grid-template-columns: 1fr; margin-top: 48px; }
  .section-reason-card-item[data-v-5f115aee] { border-bottom: 1px solid #c9ccc4; border-right: 1px solid #c9ccc4; min-height: 0; }
}
</style>
<style scoped>
.new-hero {
  background: #102d26;
  color: #f6f3ea;
  min-height: 680px;
  overflow: hidden;
  position: relative;
}
.new-hero::after {
  border: 1px solid rgba(237, 191, 94, 0.18);
  border-radius: 50%;
  content: "";
  height: 520px;
  position: absolute;
  right: -260px;
  top: -220px;
  width: 520px;
}
.new-hero-inner {
  display: grid;
  grid-template-columns: minmax(0, 0.82fr) minmax(560px, 1.18fr);
  margin: 0 auto;
  max-width: 1440px;
  min-height: 680px;
  padding: 72px 56px 76px;
  position: relative;
}
.new-hero-copy {
  align-self: center;
  max-width: 600px;
  padding-right: 56px;
  text-align: left;
}
.new-hero-eyebrow,
.new-capabilities-head > p {
  color: #edbf5e;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.16em;
  margin: 0 0 24px;
  text-transform: uppercase;
}
.new-hero-title {
  color: #f6f3ea;
  font-family: Georgia, "Times New Roman", serif;
  font-size: 58px;
  font-weight: 400;
  line-height: 1.04;
  margin: 0;
  max-width: 590px;
}
.new-hero-subtitle {
  color: rgba(246, 243, 234, 0.68);
  font-size: 17px;
  line-height: 1.75;
  margin: 28px 0 0;
  max-width: 540px;
}
.new-hero-actions {
  display: flex;
  gap: 12px;
  margin-top: 36px;
}
.new-button {
  align-items: center;
  border: 1px solid rgba(246, 243, 234, 0.28);
  border-radius: 2px;
  cursor: pointer;
  display: inline-flex;
  font-family: inherit;
  font-size: 14px;
  font-weight: 600;
  gap: 18px;
  justify-content: center;
  min-height: 50px;
  padding: 0 22px;
  text-decoration: none;
}
.new-button-primary {
  background: #edbf5e;
  border-color: #edbf5e;
  color: #102d26;
}
.new-button-primary:hover { background: #f5cf7c; }
.new-button-secondary { color: #f6f3ea; }
.new-button-secondary:hover { background: rgba(255, 255, 255, 0.08); }
.new-hero-metrics {
  border-top: 1px solid rgba(246, 243, 234, 0.16);
  display: grid;
  gap: 18px;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  margin-top: 54px;
  padding-top: 22px;
}
.new-metric { display: flex; flex-direction: column; }
.new-metric strong {
  color: #f6f3ea;
  font-family: Georgia, "Times New Roman", serif;
  font-size: 26px;
  font-weight: 400;
}
.new-metric span {
  color: rgba(246, 243, 234, 0.52);
  font-size: 11px;
  margin-top: 4px;
}
.new-product-stage {
  align-self: center;
  background: #dfe7dc;
  margin-right: -140px;
  min-height: 484px;
  padding: 58px 0 48px 50px;
  position: relative;
}
.new-stage-label {
  align-items: center;
  color: #38564d;
  display: flex;
  font-size: 11px;
  font-weight: 700;
  gap: 8px;
  letter-spacing: 0.08em;
  margin-bottom: 15px;
  text-transform: uppercase;
}
.new-stage-status {
  background: #d95d39;
  border-radius: 50%;
  height: 7px;
  width: 7px;
}
.new-product-window {
  background: #fff;
  border: 1px solid rgba(16, 45, 38, 0.1);
  box-shadow: 0 26px 60px rgba(12, 38, 31, 0.22);
  overflow: hidden;
  width: min(780px, calc(100vw - 60px));
}
.new-window-bar {
  align-items: center;
  background: #f6f3ea;
  border-bottom: 1px solid #e7e5dd;
  display: flex;
  gap: 6px;
  height: 34px;
  padding: 0 13px;
}
.new-window-bar > span {
  background: #c7cec8;
  border-radius: 50%;
  height: 6px;
  width: 6px;
}
.new-window-bar small {
  color: #7a8782;
  font-size: 8px;
  letter-spacing: 0.1em;
  margin-left: 10px;
}
.new-product-video { display: block; height: auto; width: 100%; }
.new-stage-note {
  color: #496159;
  font-family: Georgia, "Times New Roman", serif;
  font-size: 14px;
  margin-top: 18px;
  max-width: 430px;
  text-align: left;
}
.new-capabilities {
  background: #f3f0e8;
  display: grid;
  gap: 80px;
  grid-template-columns: 0.76fr 1.24fr;
  margin: 0 auto;
  max-width: none;
  padding: 108px max(42px, calc((100vw - 1328px) / 2));
  text-align: left;
}
.new-capabilities-head { max-width: 430px; }
.new-capabilities-head > p { color: #b36b33; margin-bottom: 26px; }
.new-capabilities-head h2 {
  color: #17352d;
  font-family: Georgia, "Times New Roman", serif;
  font-size: 50px;
  font-weight: 400;
  line-height: 1.1;
  margin: 0 0 25px;
}
.new-capabilities-head > span { color: #6d756f; font-size: 15px; line-height: 1.8; }
.new-capability-list { border-top: 1px solid #c8cbc2; }
.new-capability-row {
  align-items: center;
  border-bottom: 1px solid #c8cbc2;
  display: grid;
  gap: 22px;
  grid-template-columns: 44px minmax(170px, 0.8fr) minmax(240px, 1.2fr) 28px;
  min-height: 92px;
  padding: 15px 0;
}
.new-capability-index { color: #b36b33; font-size: 11px; }
.new-capability-row h3 { color: #17352d; font-size: 16px; font-weight: 650; margin: 0; }
.new-capability-row p { color: #717973; font-size: 13px; line-height: 1.6; margin: 0; }
.new-capability-arrow { color: #17352d; font-size: 19px; text-align: right; }

@media (max-width: 1100px) {
  .new-hero-inner { grid-template-columns: 1fr; padding: 64px 36px; }
  .new-hero-copy { max-width: 720px; padding-right: 0; }
  .new-product-stage { margin: 60px -36px -64px 90px; min-height: auto; padding: 40px 0 48px 40px; }
  .new-product-window { width: calc(100vw - 130px); }
  .new-capabilities { gap: 48px; grid-template-columns: 1fr; }
}
@media (max-width: 700px) {
  .new-hero-inner { min-height: auto; padding: 54px 20px 0; }
  .new-hero-title { font-size: 39px; overflow-wrap: anywhere; }
  .new-hero-subtitle { font-size: 15px; }
  .new-hero-actions { align-items: stretch; flex-direction: column; }
  .new-hero-metrics { margin-top: 40px; }
  .new-product-stage { margin: 44px -20px 0; padding: 28px 20px 38px; }
  .new-product-window { width: 100%; }
  .new-stage-note { font-size: 13px; }
  .new-capabilities { padding: 72px 20px; }
  .new-capabilities-head h2 { font-size: 38px; }
  .new-capability-row { gap: 12px; grid-template-columns: 34px 1fr 20px; padding: 22px 0; }
  .new-capability-row p { display: none; }
}
</style>
